/**
 * @flow
 * @relayHash 362214e9291b552326df0c9841011060
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TravelerListItem_DeleteTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type TravelerListItem_DeleteTraveler_MutationResponse = {|
  +deleteTraveler: ?{|
    +trip: ?{|
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +numTravelers: ?number;
    |};
  |};
|};
*/


/*
mutation TravelerListItem_DeleteTraveler_Mutation(
  $input: DeleteTravelerInput!
) {
  deleteTraveler(input: $input) {
    trip {
      travelers {
        id
      }
      tripName
      primaryTravelerName
      numTravelers
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelerListItem_DeleteTraveler_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteTravelerInput!"
          }
        ],
        "concreteType": "DeleteTravelerPayload",
        "name": "deleteTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numTravelers",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TravelerListItem_DeleteTraveler_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "TravelerListItem_DeleteTraveler_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteTravelerInput!"
          }
        ],
        "concreteType": "DeleteTravelerPayload",
        "name": "deleteTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numTravelers",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation TravelerListItem_DeleteTraveler_Mutation(\n  $input: DeleteTravelerInput!\n) {\n  deleteTraveler(input: $input) {\n    trip {\n      travelers {\n        id\n      }\n      tripName\n      primaryTravelerName\n      numTravelers\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Trips/__generated__/TravelerListItem_DeleteTraveler_Mutation.graphql.js